<script setup lang="ts">
import { defineProps } from "vue";

const props = defineProps<{
  text: string;
}>();
</script>

<template>
  <p
    class="text-xl md:text-2xl w-full md:text-3xl tracking-wide z-50 break-words text-white"
  >
    {{ props.text }}
  </p>
</template>
